import { ProfileOutlined } from "@ant-design/icons";
import { Logout } from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import { logout } from "@valenzinsights/services";
import { clearLocalStorage } from "@valenzinsights/utils";

import { useMsal } from "@azure/msal-react";
import { IUserconfiguration } from "@valenzinsights/react-core";
import { useNavigate } from "react-router";

const LogoutComponent = () => {
	const { instance } = useMsal();

	const navigate = useNavigate();

	const handleLogIn = () => {
		logout(instance);
		navigate("/");
		clearLocalStorage();
	};

	return (
		<MenuItem
			onClick={handleLogIn}
			sx={{
				width: "100%",
				justifyContent: "left",
				fontSize: "14px",
				color: "#000",
				paddingLeft: "16px",
				margin: "4px 0",
			}}
		>
			<Logout sx={{ color: "#bbb", fontSize: "15px", mr: "16px" }} /> Logout
		</MenuItem>
	);
};

export const profileListItem: IUserconfiguration = {
	id: "group-home",
	title: "",
	icon: ProfileOutlined,
	children: [
		{
			id: "1",
			title: "Logout",
			component: LogoutComponent,
		},
	],
};
